<div class="subscription-container">
  <div class="header">
    <div class="title-with-icon">
      <img routerLink="/settings" src="assets/images/leftArrow.png"/>
      <h2>Subscription Details</h2>
    </div>

    <p class="texto" style="margin-left: 27px;">Stay on top of your plan details, payment, and storage usage</p>

    <div class="btn-with-icon">
      <!-- <i class="bi bi-info-circle"></i> -->
    </div>

   </div>
   <hr />

  <div class="card-wrapper">
    <!-- Left Card: Plan Info -->
    <div class="card">
      <div class="card-header">
        <div class="plan-type">
          <strong>Basic Plan</strong>
          <span class="badge">Yearly</span>
          <p class="texto">Our most popular plan </p>
        </div>
        <div class="price">
          <span class="amount">$4.99</span>
          <span class="per">per annum</span>
        </div>
      </div>

      <div class="usage">
        <p>2GB / 5GB Storage Used</p>
        <div class="progress-bar">
          <div class="progress" style="width: 35%"></div>
        </div>

        <button class="primary-btn" style="margin-top: -20px;">Upgrade Plan →</button>
      </div>

    </div>

    <!-- Right Card: Payment Info -->
    <div class="card">
      <div class="payment-info">
        <h4>Next Payment</h4>
        <p class="texto">Your next payment scheduled date</p>
        <p class="renewal-date">
          Renewal Date: <span class="highlight">22nd December 2024</span>
        </p>
        <button class="primary-btn">Pay Now →</button>
      </div>
    </div>
  </div>
</div>
